import { render } from "./AdminNews.vue?vue&type=template&id=d6b8c0b4"
import script from "./AdminNews.vue?vue&type=script&lang=js"
export * from "./AdminNews.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__